import React from "react";
import { Button, rem } from "@mantine/core";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getFirebaseAuth } from "@/firebase";
import { useBranding } from "@/context/BrandingContext";
import { useAuth } from "@/context/AuthContext";

// 1. Het Google Icoon (SVG)
function GoogleIcon(props: React.ComponentPropsWithoutRef<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 256 262"
      style={{ width: rem(18), height: rem(18), ...props.style }}
      {...props}
    >
      <path
        fill="#4285F4"
        d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
      />
      <path
        fill="#34A853"
        d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
      />
      <path
        fill="#FBBC05"
        d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
      />
      <path
        fill="#EB4335"
        d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
      />
    </svg>
  );
}

// 2. De Login Knop Component
export default function GoogleLoginButton() {
  // White-label (F2): hide Google sign-in on a partner domain that has no OWN
  // Firebase project (the Google popup would show "Verity"), and until Firebase
  // is initialised. Magic-link sign-in stays available in that case.
  const { googleSignInEnabled } = useBranding();
  const { clearAuthError, reportAuthError } = useAuth();

  const login = async () => {
    // Clicking sign-in is the explicit new attempt that may clear a previous
    // failure — AuthContext keeps it sticky otherwise, so without this the
    // message from the last attempt would still be on screen during this one.
    clearAuthError();
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(getFirebaseAuth(), provider);
      // AuthContext handles setUser + redirect from onAuthStateChanged.
    } catch (err: any) {
      // Closing the popup is a deliberate cancel, not a failure — saying
      // anything there would be noise on a screen the user just dismissed.
      const code = typeof err?.code === "string" ? err.code : "";
      if (
        code === "auth/popup-closed-by-user" ||
        code === "auth/cancelled-popup-request"
      ) {
        return;
      }
      // Log the CODE, never the error object: Sentry turns console arguments
      // into breadcrumbs, and a Firebase error can carry the email in its
      // customData.
      console.error("Google sign-in failed:", code || "unknown");
      reportAuthError({ kind: "unknown" });
    }
  };

  if (!googleSignInEnabled) return null;

  return (
    <Button
      variant="default"
      fullWidth
      radius="xl"
      size="md"
      onClick={login} // <--- Hier koppelen we jouw logica
      leftSection={<GoogleIcon />}
      styles={{
        root: {
          fontWeight: 600,
          color: "#333",
          // Liquid Glass styling: semi-transparant wit zodat het blendt met de login kaart
          borderColor: "rgba(0,0,0,0.1)",
          backgroundColor: "rgba(255,255,255,0.8)",
        },
        inner: { justifyContent: "center" },
      }}
    >
      Continue with Google
    </Button>
  );
}
